<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Vestiging <span class="u-hidden-xsl-down">gebruikers</span> bewerken</h3>

                <router-link to="/admin/storec-mobiel/locations" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug <span class="u-hidden-xsl-down">naar overzicht</span>
                </router-link>
            </app-intro>

            <div class="c-loading" v-if="loading">
                <spinner/>
                Bezig met laden van de gebruiker...
            </div>

            <transition-group name="fade" tag="section" v-if="!loading">
                <form v-on:submit.prevent="handleSubmit" class="form form---tint" novalidate key="form">
                    <div class="g-gap:2-xs g-gap:2-sm>sm || o-card">

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Vestiging</h4>

                            <div class="form-group">
                                <label class="u-sr-only">Email:</label>
                                <div class="form-control-static">{{ location.Vestigingsnaam }}</div>
                            </div>

                            <div class="form-group">
                                <label class="u-sr-only">Naam:</label>
                                <div class="form-control-static">{{ location.Vestigingsadres }}</div>
                            </div>
                        </div>

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Gebruikers</h4>

                            <div class="form-checkboxes" v-if="users.length">

                                <div class="custom-checkbox" v-for="(user, index) in users" :key="user.GebruikerMobielID">
                                    <label :for="`user-${user.GebruikerMobielID}`" class="custom-control-label">
                                        <input type="checkbox" v-model="connectedUsers" :value="user.GebruikerMobielID" :name="`GebruikerMobielID[${index}]`" :id="`user-${user.GebruikerMobielID}`" class="custom-control-input" />
                                        <span class="custom-control-name custom-control-name--reset">{{ user.Naam }}</span>
                                    </label>
                                </div>

                            </div>

                            <div v-else>
                                <p>Geen gebruikers gevonden</p>
                            </div>
                        </div>
                    </div>

                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.updating">
                        <span v-show="status.updating"><spinner/></span>
                        <span v-show="!status.updating">Vestiging wijzigen</span>
                        <svg v-show="!status.updating" xmlns="http://www.w3.org/2000/svg" width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                <path d="M1 7.438h12.875"/>
                                <path d="M7.437 1v12.875"/>
                            </g>
                        </svg>
                    </button>
                </form>

            </transition-group>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Spinner from '../../components/Spinner.vue';
    import normalizeFormData from '../../helpers/normalizeFormData';
    import { locationService, storecMobielService } from '../../services';

    export default {
        components: {
            Spinner,
            AppIntro,
        },
        data () {
            return {
                loading: true,
                submitted: false,
                disabled: false,
                location: {
                    Vestigingsnaam: '',
                    Vestigingsadres: '',
                },
                users: [],
                connectedUsers: [],
            };
        },
        computed: {
            ...mapState('storecMobiel', ['status']),
        },
        async created () {
            await this.getLocation();
            await this.getUsers();

            // reset loading
            this.loading = false;
        },
        methods: {
            getLocation () {
                return locationService
                    .get(this.$route.params.id)
                    .then((result) => {
                        this.location = result;
                    }).catch(() => {
                        this.loading = false;
                    });
            },
            getUsers () {
                return storecMobielService
                    .listLocations(this.$route.params.id)
                    .then((result) => {
                        this.users = result;

                        // get the connected users
                        const filtered = result.filter((item) => item.Gekoppeld === 'Ja');
                        this.connectedUsers = filtered.map((item) => item.GebruikerMobielID);
                    }).catch(() => {
                        this.loading = false;
                    });
            },
            handleSubmit (e) {
                this.submitted = true;

                // normalize form data
                const data = normalizeFormData(e.target);

                // get the id
                const id = this.$route.params.id;

                // kick off the update
                this.$store.dispatch('storecMobiel/updateLocation', { id, data });
            },
        },

    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    /*.table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }
    }*/
</style>
